import jQuery from 'jquery';
import './dynamicModal';
import * as Utility from './utility.js';
(function ($) {
    let NHN_ArrayOfGoogleMapMarkers = [];
    let NHN_GoogleMap;
    bindShareButtons();
    bindAvailabilityDropdownCloseEvent();
    bindPriceDropdownMenuEvents();
    bindSearchFilterControls();
    document.addEventListener('searchfilterchange', function (event) {
        console.log('[searchfilterchange]');
        console.log(event.detail);
        let shouldUpdateMap = event.detail.shouldUpdateMap;
        let additionalData = event.detail.additionalData;
        console.log('[searchfilterchange] [shouldUpdateMap]' + shouldUpdateMap);
        if (shouldUpdateMap && shouldUpdateMap == true) {
            if (
                additionalData &&
                additionalData.listOfRecords &&
                additionalData.listOfRecords.length > 0
            ) {
                setMarkersFromMapData(NHN_GoogleMap, additionalData.listOfRecords);
            } else {
                setMarkersFromMapData(NHN_GoogleMap);
            }
        }
    });
    if ($('.appssr .page-link').length > 0) {
        console.log('[appssr .page-link]');
        $('.appssr .page-link').on('click', function (e) {
            e.preventDefault();
            console.log('[page-link] [click]');
            let filterValues = getAllSelectedFilterValues();
            filterValues['PageIndex'] = this.dataset.pindex;
            console.log(filterValues);
            let selectedCity = document.getElementById('SelectCity').value;
            processFilterChange(filterValues, selectedCity, true);
        });
    }
    function bindSearchFilterControls() {
        $('#resetSearchFilters').on('click', function (e) {
            e.preventDefault();
            console.log('[resetSearchFilters] [click]');
            reloadPageWithCity();
        });
        $('#toggleFilters').on('click', function (e) {
            e.preventDefault();
            console.log('[toggleFilters] [click]');
            $('.search-result-filters__controls').toggleClass('d-none');
        });
        $('#toggleListOnly,#toggleMapOnly').on('click', function (e) {
            console.log('[toggleListOnly]');
            console.log(e.currentTarget.id);
            console.log(e.currentTarget.dataset.target);
            let targetElementSelector = e.currentTarget.dataset.target;
            if (!$(targetElementSelector).hasClass('d-block')) {
                $(targetElementSelector).addClass('d-block');
            }
            if ($(targetElementSelector).hasClass('d-none')) {
                $(targetElementSelector).removeClass('d-none');
            }
            if (e.currentTarget.id == 'toggleListOnly') {
                hideOtherListingSection('toggleMapOnly');
            } else {
                hideOtherListingSection('toggleListOnly');
            }
        });
        if ($('.search-result-filters').length > 0) {
            let filterValues = {};
            let selectedCity = document.getElementById('SelectCity').value;
            $('.search-result-filters select').on('change', function () {
                filterValues = getAllSelectedFilterValues();
                processFilterChange(filterValues, selectedCity);
            });
            $("#dropdownMenuAvailabilityMenuOptionsWrapper input[name='checkboxAvailability']").on(
                'change',
                function () {
                    if ($(this).val() !== 'All') {
                        // option other then "All" is selected
                        resetCheckboxAll();
                    } else {
                        // option "All" is selected
                        toggleAvailabilityCheckboxes($(this).is(':checked'));
                    }
                }
            );
        }
    }
    function hideOtherListingSection(otherElementId) {
        let btnElement = document.getElementById(otherElementId);
        if (btnElement) {
            let otherElementSelector = btnElement.dataset.target;
            $(otherElementSelector).addClass('d-none');
        }
    }
    function toggleAvailabilityCheckboxes(shouldCheck) {
        $('#checkboxAvailability2').prop('checked', shouldCheck);
        $('#checkboxAvailability3').prop('checked', shouldCheck);
        $('#checkboxAvailability4').prop('checked', shouldCheck);
        $('#checkboxAvailability5').prop('checked', shouldCheck);
    }
    function resetCheckboxAll() {
        let allValues = ['0', '1', '2', '3'];
        let selectedValues = [];
        $("#dropdownMenuAvailabilityMenuOptionsWrapper input[name='checkboxAvailability']").each(
            function () {
                const isChecked = $(this).is(':checked');
                if (isChecked && $(this).val() !== 'All') {
                    selectedValues.push($(this).val());
                }
            }
        );
        let isAllItemExistObj = isAllItemExist(selectedValues, allValues);
        if (isAllItemExistObj) {
            $('#checkboxAvailability1').prop('checked', true);
        } else {
            $('#checkboxAvailability1').prop('checked', false);
        }
    }
    function bindAvailabilityDropdownCloseEvent() {
        var dropdownMenuAvailabilityMenuElement = document.getElementById(
            'dropdownMenuAvailabilityMenu'
        );
        if (dropdownMenuAvailabilityMenuElement) {
            dropdownMenuAvailabilityMenuElement.addEventListener('hide.bs.dropdown', function () {
                console.log('[bindAvailabilityDropdownCloseEvent]');
                let filterValues = getAllSelectedFilterValues();
                setTextOnAvaibilityDropdown(filterValues);
                processFilterChange(filterValues, document.getElementById('SelectCity').value);
            });
        }
    }
    function bindPriceDropdownMenuEvents() {
        var dropdownMenuPriceMenuElement = document.getElementById('dropdownMenuPriceMenu');
        if (dropdownMenuPriceMenuElement) {
            dropdownMenuPriceMenuElement.addEventListener('hide.bs.dropdown', function () {
                console.log('[dropdownMenuPriceMenuElement] [hide]');
                let priceRange = getPriceRange();
                let priceElement = document.getElementById('InputPrice');
                if (priceElement) {
                    if (priceRange && priceRange != '') {
                        priceElement.value = priceRange;
                    } else {
                        priceElement.value = '';
                    }
                }
                setTextOnPriceDropdown();
                let filterValues = getAllSelectedFilterValues();
                processFilterChange(filterValues, document.getElementById('SelectCity').value);
            });
            dropdownMenuPriceMenuElement.addEventListener('show.bs.dropdown', function () {
                console.log('[dropdownMenuPriceMenuElement] [show]');
                clearPriceUlList('SelectMinPrice');
                clearPriceUlList('SelectMaxPrice');
                buildMinPriceUlList();
            });
        }
    }
    function setTextOnPriceDropdown() {
        let priceElement = document.getElementById('InputPrice');
        let selectedPrice = '';
        if (priceElement) {
            if (priceElement.value && priceElement.value != '') {
                selectedPrice = priceElement.value;
            } else {
                selectedPrice = 'Any Price';
            }
        }
        document.getElementById('dropdownMenuPriceMenu').innerHTML =
            getFormattedPriceForDropdown(selectedPrice);
    }
    function getFormattedPriceForDropdown(price) {
        let formattedPrice = 'Any price';
        if (price) {
            if (price.indexOf('-') == 0) {
                console.log('ONLY MAX price');
                formattedPrice = 'max ' + abbreviateNumber(price.replace('-', ''));
            } else if (price.indexOf('-') > 0) {
                let priceStrLength = price.length;
                if (price.indexOf('-') == priceStrLength - 1) {
                    console.log('ONLY MIN price');
                    formattedPrice = 'min ' + abbreviateNumber(price.replace('-', ''));
                } else {
                    console.log('BOTH MIN MAX price');
                    let minMaxPrice = price.split('-');
                    formattedPrice =
                        abbreviateNumber(minMaxPrice[0]) + '-' + abbreviateNumber(minMaxPrice[1]);
                }
            } else {
                console.log('empty' + price);
            }
        } else {
            console.log('undefined' + price);
        }

        return formattedPrice;
    }
    function abbreviateNumber(number) {
        var SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
        // what tier? (determines SI symbol)
        var tier = (Math.log10(Math.abs(number)) / 3) | 0;

        // if zero, we don't need a suffix
        if (tier == 0) return number;

        // get suffix and determine scale
        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3);

        // scale the number
        var scaled = number / scale;

        // format number and add suffix
        return scaled + suffix;
    }
    function clearPriceUlList(ulSelectorId) {
        let ulElement = document.getElementById(ulSelectorId);
        if (ulElement) {
            ulElement.innerHTML = '';
        }
    }
    function buildMinPriceUlList() {
        let ulPriceElement = document.getElementById('SelectMinPrice');
        if (ulPriceElement) {
            ulPriceElement.innerHTML = getPriceOptionsListOfElements(true, 0);
            let priceLiItems = $('.nhn-min-price-control');
            if (priceLiItems.length > 0) {
                $(priceLiItems).on('click', function (e) {
                    console.log('[nhn-min-price-control] clicked');
                    let valueSelected = e.currentTarget.dataset.value;
                    setMinPrice(valueSelected);
                    buildMaxPriceUlList(valueSelected);
                });
            }
        }
    }
    function buildMaxPriceUlList(minPriceSelected) {
        let ulPriceElement = document.getElementById('SelectMaxPrice');
        if (ulPriceElement) {
            ulPriceElement.innerHTML = getPriceOptionsListOfElements(false, minPriceSelected);
            let priceLiItems = $('.nhn-max-price-control');
            if (priceLiItems.length > 0) {
                $(priceLiItems).on('click', function (e) {
                    console.log('[nhn-max-price-control] clicked');
                    let valueSelected = e.currentTarget.dataset.value;
                    setMaxPrice(valueSelected);
                });
            }
        }
    }
    function setMinPrice(price) {
        let priceElement = document.getElementById('InputMinPrice');
        if (priceElement && price && parseFloat(price) >= 0) {
            priceElement.value = parseFloat(price);
        } else {
            priceElement.value = '';
        }
    }
    function setMaxPrice(price) {
        let priceElement = document.getElementById('InputMaxPrice');
        if (priceElement && price && parseFloat(price) >= 0) {
            priceElement.value = parseFloat(price);
        } else {
            priceElement.value = '';
        }
    }
    function getPriceRange() {
        let priceRange = '';
        let minPriceElement = document.getElementById('InputMinPrice');
        if (minPriceElement && parseFloat(minPriceElement.value) >= 0) {
            priceRange = parseFloat(minPriceElement.value);
        }
        if (priceRange) {
            priceRange += '-';
        } else {
            priceRange = '-';
        }
        let maxPriceElement = document.getElementById('InputMaxPrice');
        if (maxPriceElement && parseFloat(maxPriceElement.value) >= 0) {
            priceRange += parseFloat(maxPriceElement.value);
        }
        if (priceRange == '-') {
            priceRange = undefined;
        }
        return priceRange;
    }
    function getPriceOptionsListOfElements(isMinPrice, startingPrice) {
        let priceOptions = getPriceOptionsByMinimum(parseFloat(startingPrice));
        console.log('[priceOptions]');
        console.log(priceOptions);
        let liItemsHtml = '';
        let nhnClass = !!isMinPrice ? 'nhn-min-price-control' : 'nhn-max-price-control';
        for (let index = 0; index < priceOptions.length; index++) {
            let item = priceOptions[index];
            let inputMinPriceControlId = 'inputMinPriceControlId' + index;
            let liItem = `<li class="list-group-item border-0 px-0">
        <label class="form-check-label cursor-pointer ${nhnClass}" data-value="${item.value}" for="${inputMinPriceControlId}">${item.text}</label>
        </li>`;
            liItemsHtml += liItem;
        }
        return liItemsHtml;
    }

    function getPriceOptionsByMinimum(minPrice) {
        let listOfPrices = [];
        let defaultPrice = minPrice && parseFloat(minPrice) >= 0 ? parseFloat(minPrice) : 0;
        for (let index = defaultPrice; index < 2000000; ) {
            listOfPrices.push(index);
            if (listOfPrices.length > 7) {
                break;
            }
            if (index < 600000) {
                index = index + 100000;
            } else if (index < 1000000) {
                index = index + 200000;
            } else if (index < 2000000) {
                index = index + 250000;
            } else {
                break;
            }
        }
        let listOfItems = [];
        for (let indx = 0; indx < listOfPrices.length; indx++) {
            let price = listOfPrices[indx];
            let label = new Intl.NumberFormat().format(price);
            listOfItems.push({ value: price, text: label });
        }
        listOfItems.push({ value: '', text: 'Any Price' });
        return listOfItems;
    }
    function setTextOnAvaibilityDropdown(filteredValues) {
        let dropdownMenuAvailabilityMenuElement = document.getElementById(
            'dropdownMenuAvailabilityMenu'
        );
        if (dropdownMenuAvailabilityMenuElement) {
            let newText = 'Availability';
            if (filteredValues && filteredValues['SelectAvailability']) {
                let selectedValue = filteredValues['SelectAvailability'];
                if (selectedValue) {
                    let selectedItemsCount = selectedValue.split(',').length;
                    if (selectedItemsCount > 0) {
                        newText = selectedItemsCount + ' selected';
                    }
                }
            }
            dropdownMenuAvailabilityMenuElement.innerHTML = newText;
        }
    }
    function getAllSelectedFilterValues() {
        let filterValues = {};
        $('.search-result-filters select').each(function () {
            let currentElementValue = $(this).val();
            let currentElementName = $(this).attr('name');
            if (currentElementValue !== undefined) {
                console.log(
                    '[currentElementName]' + currentElementName + ' => ' + currentElementValue
                );
                if (currentElementName === 'SelectListingStatus' && currentElementValue != '') {
                    currentElementValue = $('#SelectListingStatus option:selected').text();
                }
                filterValues[currentElementName] = currentElementValue;
            } else {
                filterValues[currentElementName] = '';
            }
        });
        let availabilityValues = [];
        $('#SelectAvailability input[name="checkboxAvailability"]:checked').each(function () {
            console.log('[SelectAvailability] input[name="checkboxAvailability"]:checked');
            console.log(this.value);
            if (this.value && this.value !== 'All') {
                availabilityValues.push(this.value);
            }
        });
        if (availabilityValues && availabilityValues.length > 0) {
            filterValues['SelectAvailability'] = availabilityValues.join(',');
        } else {
            filterValues['SelectAvailability'] = '';
        }
        let priceRangeElement = document.getElementById('InputPrice');
        if (priceRangeElement && priceRangeElement.value && priceRangeElement.value != '') {
            filterValues['SelectPrice'] = priceRangeElement.value;
        } else {
            filterValues['SelectPrice'] = '';
        }
        let googlemapElement = document.getElementById('googlemap');
        if (
            googlemapElement &&
            googlemapElement.dataset &&
            googlemapElement.dataset.latlngRange &&
            googlemapElement.dataset.latlngRange != ''
        ) {
            filterValues['SelectLatLng'] = googlemapElement.dataset.latlngRange;
        } else {
            filterValues['SelectLatLng'] = '';
        }
        // NOTE: if want to reset page number on search filter. try to add following
        // filterValues['PageIndex'] = 0;
        return filterValues;
    }
    function isAllItemExist(sourceArr, masterArray) {
        return masterArray.every((r) => sourceArr.includes(r));
    }
    function reloadPageWithCity() {
        let selectedCity = document.getElementById('SelectCity').value;
        if (selectedCity) {
            window.location.href = Utility.getAbsolutePath('/newhomes/' + selectedCity);
        } else {
            window.location.reload();
        }
    }
    function processFilterChange(filterValues, originalSelectedCity, isTriggerSourceMap) {
        console.log('[processFilterChange]');
        console.log(filterValues);
        console.log(originalSelectedCity);
        if (
            originalSelectedCity &&
            filterValues['SelectCity'] &&
            filterValues['SelectCity'] !== originalSelectedCity
        ) {
            console.log(filterValues);
            window.location.href = Utility.getAbsolutePath(
                '/newhomes/' + filterValues['SelectCity']
            );
        } else {
            console.log('partial refresh [filterValues]');
            console.log(filterValues);
            document.getElementById('razorapp').innerHTML = '';
            let eventData = { url: window.location.href, filters: filterValues };
            let searchParams = [];

            if (filterValues['SelectCommunities'] && filterValues['SelectCommunities'] !== '') {
                searchParams.push('com=' + filterValues['SelectCommunities']);
            }

            if (filterValues['SelectPropertyType'] && filterValues['SelectPropertyType'] !== '') {
                searchParams.push('housetype=' + filterValues['SelectPropertyType']);
            }
            if (
                filterValues['SelectBeds'] &&
                filterValues['SelectBeds'] !== '' &&
                parseFloat(filterValues['SelectBeds']) > 0
            ) {
                searchParams.push('bed=' + parseFloat(filterValues['SelectBeds']));
            }
            if (filterValues['SelectListingStatus'] && filterValues['SelectListingStatus'] !== '') {
                searchParams.push('status=' + filterValues['SelectListingStatus']);
            }
            if (filterValues['SelectPrice'] && filterValues['SelectPrice'] !== '') {
                searchParams.push('price=' + filterValues['SelectPrice']);
            }
            if (filterValues['SelectAvailability'] && filterValues['SelectAvailability'] !== '') {
                searchParams.push('availability=' + filterValues['SelectAvailability']);
            }
            if (filterValues['SelectLatLng'] && filterValues['SelectLatLng'] !== '') {
                let encodedLatLng = encodeURIComponent(filterValues['SelectLatLng']);
                searchParams.push('latlngrange=' + encodedLatLng);
            }
            let currentPage = 1;
            if (filterValues['PageIndex'] && filterValues['PageIndex'] !== '') {
                searchParams.push('page=' + parseFloat(filterValues['PageIndex']));
                currentPage = parseFloat(filterValues['PageIndex']);
            }
            let searchUrl = getSearchurlByEndpointAndParams(
                '/api/search/' + originalSelectedCity,
                searchParams
            );

            fetch(searchUrl) // Call the fetch function passing the url of the API as a parameter
                .then((res) => res.json())
                .then(function (res) {
                    console.log('[fetch][currentPage]' + currentPage);
                    eventData.additionalData = res;
                    eventData.currentPage = currentPage;
                    eventData.shouldUpdateMap =
                        isTriggerSourceMap && isTriggerSourceMap == true ? false : true;
                    const cevent = new CustomEvent('searchfilterchange', { detail: eventData });
                    document.dispatchEvent(cevent);
                })
                .catch(function (err) {
                    console.log('[CATCH] err');
                    console.log(err);
                });
        }
    }
    function getSearchurlByEndpointAndParams(url, arrayOfParams) {
        if (arrayOfParams && arrayOfParams.length > 0) {
            return url + '?' + arrayOfParams.join('&');
        }
        return url;
    }
    function bindShareButtons() {
        console.log('[bindShareButtons]');
        $('.share-link').on('click', function () {
            let elementText = $(this).attr('title');
            let elementLink = this.dataset.link;
            console.log('[bindShareButtons] DATASET');
            console.log(this.dataset);
            if (elementLink && elementLink.length > 0) {
                let sharableLink = Utility.getAbsolutePath(elementLink);
                console.log('[bindShareButtons] sharableLink: ' + sharableLink);
                if (navigator.share && isBrowserMobile()) {
                    navigator
                        .share({
                            title: elementText,
                            text: sharableLink,
                            url: sharableLink,
                        })
                        .then(() => console.log('[bindShareButtons] Successful share'))
                        .catch((error) => console.log('[bindShareButtons] Error sharing', error));
                } else {
                    console.log(
                        '[bindShareButtons] Share not supported on this browser, do it the old way.'
                    );
                    let copyToClipboardTextWrap =
                        "<div class='copy-to-clipboard-text'>" + sharableLink + '<div>';
                    new DynamicModal(
                        'copyClipboardModal',
                        elementText, // title
                        copyToClipboardTextWrap, // text
                        'Close', // noBtnName
                        'Copy Link', // yesBtnName
                        function () {
                            // Copy the text inside the text field
                            if (navigator.clipboard) {
                                navigator.clipboard.writeText(sharableLink);
                                let modalElement = $(this)
                                    .parents('.modal-content')
                                    .find('.copy-to-clipboard-text');
                                console.log($(modalElement));
                                $(modalElement).addClass('mark');
                                setTimeout(function () {
                                    $(modalElement).removeClass('mark');
                                }, 2000);
                            } else {
                                alert('Link is not copied. Please copy it manually');
                            }
                        } // yesBtnFunction
                    ).show();
                }
            }
        });
    }
    function isBrowserMobile() {
        let check = false;
        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }
    function initMap() {
        console.log('GOOGLE MAP');
        console.log('[mapdata]');
        let mapdataElement = document.getElementById('mapdata');
        if (mapdataElement) {
            console.log(mapdataElement.value);
        }
        const CALGARY_LOCATION = { lat: 51.049999, lng: -114.06666 };
        let mapOptions = {
            center: CALGARY_LOCATION,
            zoom: 9,
            minZoom: 9,
            mapId: 'googlemap',
        };
        NHN_GoogleMap = new google.maps.Map(document.getElementById('googlemap'), mapOptions);
        window.shouldTriggerIdealEvent = false;
        google.maps.event.addListener(NHN_GoogleMap, 'idle', function () {
            try {
                var bounds = NHN_GoogleMap.getBounds();
                var sw = bounds.getSouthWest();
                var ne = bounds.getNorthEast();
                var args = {
                    NW: { lat: ne.lat(), lng: sw.lng() },
                    NE: { lat: ne.lat(), lng: ne.lng() },
                    SE: { lat: sw.lat(), lng: ne.lng() },
                    SW: { lat: sw.lat(), lng: sw.lng() },
                };
                let range = [];
                range.push(args.NE.lng);
                range.push(args.NW.lng);
                range.push(args.SE.lat);
                range.push(args.NE.lat);
                /*{
                    minlng: args.NE.lng,
                    maxlng: args.NW.lng,
                    minlat: args.SE.lat,
                    maxlat: args.NE.lat,
                };*/
                console.log('range of lat long of current map view: ');
                console.log(range);
                if (!!window.shouldTriggerIdealEvent) {
                    triggerFilterChangeOnMapBoundChange(range);
                }
                window.shouldTriggerIdealEvent = true;
            } catch (err) {
                console.log('err ' + err);
            }
        });
        setMarkersFromMapData(NHN_GoogleMap, window.mapData);
    }
    function triggerFilterChangeOnMapBoundChange(range) {
        console.log('[triggerFilterChangeOnMapBoundChange]');
        let selectedCity = document.getElementById('SelectCity').value;
        setLatLngRange(range.join(','));
        let filterValues = getAllSelectedFilterValues();
        console.log('[triggerFilterChangeOnMapBoundChange] [filterValues]');
        console.log(filterValues);
        processFilterChange(filterValues, selectedCity, true);
    }
    function setLatLngRange(value) {
        let googlemapElement = document.getElementById('googlemap');
        if (googlemapElement && value && value != '') {
            googlemapElement.dataset.latlngRange = value;
        } else if (googlemapElement) {
            googlemapElement.dataset.latlngRange = '';
        }
    }
    function setMarkersFromMapData(googleMap, mapData) {
        clearExistingMapMarkers();
        const svgMarker = {
            path: 'M5.5,92.4c-1,0-2-0.3-2.9-0.8C1,90.6,0,88.8,0,86.9V31.2L40.4,0l40.4,31.2v55.7c0,1.9-1,3.7-2.7,4.8c-1.7,1-3.7,1.1-5.4,0.2L41.3,75.2L8.1,91.9C7.2,92.2,6.4,92.4,5.5,92.4 M8.9,35.6v45.9l22.8-11.4l-1-0.5c-6.1-3.2-9.8-9.5-9.8-16.3c0-10.2,8.3-18.5,18.5-18.5h3.1c10.2,0,18.5,8.3,18.5,18.5v0.7c0,6.9-3.8,13.2-9.9,16.4l21,11.1V35.6L40.4,11.2L8.9,35.6zM39.3,43.6c-5.3,0-9.6,4.3-9.6,9.6c0,3.6,2,6.8,5.1,8.5l6.6,3.5l5.3-2.7c3.3-1.6,5.3-4.9,5.3-8.6v-0.7c0-5.3-4.3-9.6-9.6-9.6L39.3,43.6L39.3,43.6z',
            fillColor: '#0a3622',
            fillOpacity: 0.9,
            strokeWeight: 0,
            rotation: 0,
            scale: 0.2,
            anchor: new google.maps.Point(0, 20),
        };

        if (mapData && mapData.length > 0) {
            let locationToCenter;
            mapData.forEach(function (elem) {
                if (elem.longitude && elem.latitude) {
                    let title = elem.title;
                    let pLong = Number(elem.longitude);
                    let pLat = Number(elem.latitude);
                    let latLong = new google.maps.LatLng(pLat, pLong);
                    if (!locationToCenter) {
                        locationToCenter = latLong;
                    }
                    // add following in Marker options to add custom marker
                    // icon: svgMarker,

                    const marker = new google.maps.marker.AdvancedMarkerElement({
                        position: latLong,
                        map: googleMap,
                    });
                    setMapMarkerInfoWindow(marker, googleMap, elem);
                    NHN_ArrayOfGoogleMapMarkers.push(marker);
                }
            });
            NHN_ArrayOfGoogleMapMarkers.forEach(function (marker) {
                marker.setMap(googleMap);
            });
            if (locationToCenter) {
                googleMap.setCenter(locationToCenter);
            }
        }
    }
    function clearExistingMapMarkers() {
        console.log('[clearExistingMapMarkers]');
        if (NHN_ArrayOfGoogleMapMarkers && NHN_ArrayOfGoogleMapMarkers.length > 0) {
            NHN_ArrayOfGoogleMapMarkers.forEach(function (marker) {
                console.log('[clearExistingMapMarkers] marker');
                marker.setMap(null);
            });
            NHN_ArrayOfGoogleMapMarkers = [];
        }
    }
    function setMapMarkerInfoWindow(marker, map, propertyData) {
        const contentString = getPropertyDataCardHtml(propertyData);
        const infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 200,
            ariaLabel: propertyData.title,
        });
        marker.addListener('click', () => {
            infowindow.open({
                anchor: marker,
                map,
            });
        });

        google.maps.event.addListener(infowindow, 'domready', () => {
            //now my elements are ready for dom manipulation

            let elements = document.getElementsByClassName('map-card-container');
            if (elements && elements.length > 0) {
                for (let i = 0; i < elements.length; i++) {
                    elements[i].addEventListener('click', openPorpertyDetailPageInNewTab, false);
                }

                function openPorpertyDetailPageInNewTab(e) {
                    if (e.currentTarget && e.currentTarget.getAttribute('data-url')) {
                        let durl = e.currentTarget.getAttribute('data-url');
                        window.open(durl, '_blank', 'noopener,noreferrer');
                    }
                }
            }
        });
    }

    function getAvailableDate(item) {
        try {
            let isMoveInReady = item.isMoveInReady && item.isMoveInReady === true ? true : false;
            if (isMoveInReady) {
                return 'Ready to move in';
            }
            let date = new Date(item.availableDate); // 2009-11-10
            let month = date.toLocaleString('default', { month: 'short' });
            let year = date.getFullYear();
            return month + ' ' + year;
        } catch (err) {
            console.log('[getAvailableDate] err');
            console.log(err);
            return '';
        }
    }

    function safeEmptyString(str) {
        if (str && str != '') {
            return str;
        }
        return str;
    }

    function safeEncodedImagePath(urlPath) {
        if (urlPath) {
            return encodeURI(urlPath);
        }
        return '';
    }
    function getPropertyDataCardHtml(item) {
        const mapContainerCLass = 'map-card-container';
        const cardBodyPadding = 'px-1';
        const imgPath = item.firstMediaFileReadModel
            ? safeEncodedImagePath(item.firstMediaFileReadModel.mediaFileImagePath)
            : '/assets/images/nhn_placeholder_more_photos_coming_soon.webp';
        const imgAltName = item.firstMediaFileReadModel
            ? safeEncodedImagePath(item.firstMediaFileReadModel.mediaFileName)
            : 'more photos coming soon';
        const beds = item.bedrooms;
        const sqft = item.sqft;
        const ownerName = item.ownerName;
        const dataUrl = '/Listings/View/' + item.idWithSlug;
        const communityNameAndCity =
            item.communityName && item.cityName
                ? item.communityName + ' &#x2022; ' + item.cityName
                : safeEmptyString(item.communityName) + ' ' + safeEmptyString(item.cityName);
        const status = item.listingStatusName;
        const availableDate = getAvailableDate(item);

        return `<div data-url="${dataUrl}" class="${mapContainerCLass} d-flex align-items-stretch cursor-pointer">
        <div
            class="card w-100 mb-3 overflow-hidden"
        >
            <img src=${imgPath} class="img-fluid mxh-20" alt=${imgAltName} />
            <div class="nhn-card-img-overlay">
                <h5 class="card-title badge bg-secondary text-dark">${status}</h5>
            </div>
            <div class="card-body ${cardBodyPadding}">
                <h5 class="card-title text-truncate nhn-highlight-header nhn-highlight-header--block">
                    ${item.title}
                </h5>
                <div class="card-text">
                    <div class="row">
                        <div class="col text-truncate text-muted">${item.streetAddress}</div>
                    </div>
                    <div class="row">
                        <div class="col text-truncate">${communityNameAndCity}</div>
                    </div>
                    <div class="row">
                        <div class="col text-muted fw-bold text-uppercase">${availableDate}</div>
                    </div>
                    <div class="row row-cols-2 align-items-center mt-2  nhn-va--middle">
                        <div class="col">
                            <span class="nhn-icon nhn-icon--bedroom nhn-icon--sm mr-1"></span>
                            <span> ${beds} Beds</span>
                        </div>
                        <div class="col">
                            <span class="nhn-icon nhn-icon--sqft nhn-icon--sm mr-1"></span>
                            <span>${sqft} sqft</span>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </div>`;
    }

    window.initMap = initMap;
})(jQuery);
